import { render, staticRenderFns } from "./FcNumberForm.vue?vue&type=template&id=4963cb59&scoped=true&"
import script from "./FcNumberForm.vue?vue&type=script&lang=ts&"
export * from "./FcNumberForm.vue?vue&type=script&lang=ts&"
import style0 from "./FcNumberForm.vue?vue&type=style&index=0&id=4963cb59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4963cb59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
